<template>
<div>
  <Header/>
  <Navigationzj/>
  <div class="hxq_subpage">
    <div class="zmpp_con w1200">
      <div class="hxq_yzjk_mbx" style="padding-left: 0px">
        <a href="/" class="allResult">首页<span class="newspan">></span></a>帮助中心
      </div>
      <div class="demo-image__preview" style="width:100%;display: inline-block;">
        <!--左侧导航开始-->
        <div>
          <LeftNavs :leftNavis='7'/>
        </div>
        <!--左侧导航结束-->
        <div class="cght_htmainrights">
          <div class="loading-wrap">
            <div class="content-title-wrap">
              <div class="content-title">如何支付</div>
            </div>
            <div class="loading-box">
              <div class="n_right_line">
                <div class="n_title_line">
                  <div class="icon-background">
                    <div class="icon-content">1</div>
                  </div>
                  <div class="n_right_head">
                    <p>支付方式</p>
                    <span>在线支付：支持支付宝/微信</span>
                  </div>
                </div>
                <div class="n_content content-with-border">
                  <table class="table-container">
                    <tbody>
                      <tr class="table-title">
                        <th id="first-table-title">支付平台</th>
                        <th id="second-table-title">支持银行卡种</th>
                        <th id="third-table-title">服务热线</th>
                      </tr>
                      <tr class="table-body first-table-body">
                        <td class="img-text">
                          <img src="../../assets/images/inco/zhifub.png">
                          <p>支付宝支付</p>
                        </td>
                        <td class="click-check">
                          <a class="click-check" href="//about.alipay.com/" target="_blank">点击查看</a>
                        </td>
                        <td>95188</td>
                      </tr>
                      <tr class="table-body">
                        <td class="img-text">
                          <img src="../../assets/images/inco/wethac.png">
                          <p>微信支付</p>
                        </td>
                        <td class="click-check">
                          <a class="click-check" href="//pay.weixin.qq.com/index.php/core/home/login" target="_blank">点击查看</a>
                        </td>
                        <td>95017</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="n_right_line">
                <div class="n_title_line">
                  <div class="icon-background">
                    <div class="icon-content">2</div>
                  </div>
                  <div class="n_right_head">
                    <p>汇款信息</p>
                    <span>银行账号信息/汇款信息</span>
                  </div>
                </div>
                <div class="n_content content-with-border">
                  <table class="table-container">
                    <tbody>
                      <tr class="table-title">
                        <th>银行账号信息</th>
                      </tr>
                      <tr class="table-body tr-item">
                        <td class="rd-item">公司名称</td>
                        <td class="rd-item">志鹏供应链（内蒙古）有限公司</td>
                      </tr>
                      <tr class="table-body tr-item">
                        <td class="rd-item">电&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;话</td>
                        <td class="rd-item">400-040-7890</td>
                      </tr>
                      <tr class="table-body tr-item">
                        <td class="rd-item">地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址</td>
                        <td class="rd-item">内蒙古自治区呼和浩特市赛罕区锡林南路与地质局南街交汇处未名楼A段1层1-0</td>
                      </tr>
                      <tr class="table-body tr-item">
                        <td class="rd-item">税&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;号</td>
                        <td class="rd-item">91150105752555279Q</td>
                      </tr>
                      <tr class="table-body tr-item">
                        <td class="rd-item">账&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;号</td>
                        <td class="rd-item">0602005209200006532</td>
                      </tr>
                      <tr class="table-body tr-item">
                        <td class="rd-item">开&nbsp;&nbsp;户&nbsp;&nbsp;行</td>
                        <td class="rd-item">工商银行呼市锡林南路支行</td>
                      </tr>
                    </tbody>
                  </table>
                  <table class="table-container">
                    <tbody>
                      <tr class="table-title">
                        <th style="width:40%">收款公司</th>
                        <th style="width:36%">开户银行</th>
                        <th style="width:24%">汇款账号</th>
                      </tr>
                      <tr class="table-body tr-item">
                        <td class="rd-item" style="width:40%">志鹏供应链（内蒙古）有限公司</td>
                        <td class="rd-item" style="width:36%">工商银行呼市锡林南路支行</td>
                        <td class="rd-item" style="width:24%">0602005209200006532</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Footer/>
</div>
</template>
<script>
import Header from '@/components/Header'
import Navigationzj from '@/components/Navigationzj'
import Footer from '@/components/Footer'
import LeftNavs from '@/components/Help/Left_navs'

export default {
  name: 'Help',
  components: {
    Header,
    Navigationzj,
    Footer,
    LeftNavs
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<style scoped>
.cght_htmainrights .loading-wrap {
  margin-left: 252px;
  top: 0;
  left: 0;
  right: 0;
}
.loading-wrap .content-title-wrap {
  height: 42px;
  background: #f7f7f7;
}
.loading-wrap .content-title-wrap .content-title {
  float: left;
  width: auto;
  height: 28px;
  font-size: 20px;
  font-weight: 400;
  color: #666;
  line-height: 42px;
  margin-left: 16px;
}
.loading-wrap .loading-box {
  background-size: 74px auto;
  border-left: 1px dashed #e8e8e8;
  margin-left: 43px;
  margin-top: 25px;
  margin-bottom: 40px;
  height: auto;
}
.n_right_line {
  padding-bottom: 40px;
}
.n_right_line .n_title_line {
  text-align: left;
  margin-left: -30px;
}
.n_right_line .n_title_line .icon-background {
  float: left;
  margin-left: 10px;
  margin-right: 11px;
  width: 40px;
  height: 40px;
  background-color: #436aa6;
  border-radius: 50%;
}
.loading-wrap .loading-box :last-child {
  padding-bottom: 0;
}
.n_right_line .n_title_line .icon-background .icon-content {
  text-align: center;
  line-height: 40px;
  font-size: 20px;
  font-weight: 600;
  color: #fff;
}
.n_right_line .n_title_line .n_right_head {
  display: inline-block;
  margin-left: 21px;
}
.n_right_line .n_title_line .n_right_head p {
  font-size: 18px;
  color: #333;
  line-height: 20px;
  margin-bottom: 6px;
}
.n_right_line .n_title_line .n_right_head span {
  display: inline;
  font-size: 14px;
  color: #666;
  line-height: 20px;
}
.n_right_line .n_content {
  margin-top: 20px;
  margin-left: 45px;
  text-align: left;
}
.n_right_line .n_content img {
  width: 855px;
}
.content-with-border {
  border-radius: 3px;
  border: 1px solid #e2e2e2;
}
.table-container {
  border-collapse: collapse;
  margin: 30px auto 40px 76px;
  width: 640px;
}
.table-container .table-title {
  height: 40px;
  border-bottom: 2px solid #e5e5e5;
}
.table-container .table-title #first-table-title {
  padding-left: 8px;
  width: 64px;
}
.table-container .table-title #second-table-title {
  width: 96px;
}
.table-container .table-title #third-table-title {
  width: 64px;
  padding-bottom: 1px!important;
}
.table-container .table-title th {
  color: #333;
  font-size: 16px;
  font-weight: 700;
}
.table-container .first-table-body td {
  padding-top: 15px;
}
.table-container .table-body .img-text {
  height: 49px;
}
.table-container .table-body .img-text img {
  width: 55px;
  float: left;
}
.table-container .table-body .img-text p {
  line-height: 48px;
  margin-left: 28px;
  float: left;
}
.table-container .tr-item {
  border-bottom: 1px dashed #999;
}
.table-container .tr-item .rd-item:first-of-type {
  width: 30%;
}
.table-container .tr-item .rd-item {
  color: #666;
  font-size: 15px;
  line-height: 36px;
}
</style>



// WEBPACK FOOTER //
// src/view/help/pay.vue